import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Icon from '../../components/common/Icon';
import { apiRequest } from '../../utils';
import './MemberHome.css';

/* Specialists directory — approved specialists with a visible profile (their services + the member
   discount). Open to every member and the contact person; being LISTED stays ecosystem + approval,
   so "edit my profile" only shows when can_edit. Backend: GET /api/bravos/specialists. Each card
   opens the PUBLIC profile (/specialist/:id). */
const Specialists = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [specialists, setSpecialists] = useState(null);
  const [canEdit, setCanEdit] = useState(false);

  const load = useCallback(() => {
    apiRequest('GET', '/bravos/specialists')
      .then((res) => { setSpecialists((res && res.specialists) || []); setCanEdit(Boolean(res && res.can_edit)); })
      .catch(() => navigate('/member-home'));
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  return (
    <Base activeNav="home">
      <Card>
        <div className="bravos-brand">
          <div>
            <Title my="0" className="mt-1">{t('specialistsDirectory')}</Title>
            <p className="bravos-brand__name">{t('specialistsDirectoryNote')}</p>
          </div>
          <button type="button" className="bravos-wallet__link bravos-members__back"
                  onClick={() => navigate('/member-home')}>
            <Icon name="angle-left" /> {t('back')}
          </button>
        </div>
        {canEdit && (
          <button type="button" className="bravos-event__claim mt-2"
                  onClick={() => navigate('/edit-specialist-profile')}>
            <Icon name="edit" className="me-1" /> {t('editMyProfile')}
          </button>
        )}
      </Card>

      {specialists === null ? (
        <Card><span className="auth__spinner" /></Card>
      ) : specialists.length === 0 ? (
        <Card><p className="text-muted mb-0">{t('noSpecialistsYet')}</p></Card>
      ) : (
        specialists.map((s) => (
          <Card key={s.partner_id}>
            <button type="button" className="bravos-spec"
                    onClick={() => navigate(`/specialist/${s.partner_id}`)}>
              {s.photo_url
                ? <img className="bravos-spec__photo" src={s.photo_url} alt="" />
                : <span className="bravos-spec__photo bravos-spec__photo--ph">
                    {(s.name || '?').slice(0, 1)}
                  </span>}
              <span className="bravos-spec__body">
                <span className="bravos-spec__name">{s.name}</span>
                {s.headline && <span className="bravos-spec__headline">{s.headline}</span>}
                {(s.roles || []).length > 0 && (
                  <span className="bravos-brand__roles">
                    {s.roles.map((r) => (
                      <span key={r.name} className="bravos-role-chip"
                            style={r.color ? { borderColor: r.color, color: r.color } : {}}>
                        {r.name}
                      </span>
                    ))}
                  </span>
                )}
                {s.discount_note && (
                  <span className="bravos-spec__discount">
                    <Icon name="ticket" className="me-1" />{s.discount_note}
                  </span>
                )}
              </span>
              <Icon name="angle-right" className="bravos-event__chev" />
            </button>
          </Card>
        ))
      )}
    </Base>
  );
};

export default Specialists;
